"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PdsPopOver = void 0;
var react_1 = __importDefault(require("react"));
var web_component_1 = require("./web-component");
var react_utils_1 = require("../utils/react-utils");
function PdsPopOver(props) {
    return (react_1.default.createElement(web_component_1.WebComponent, { tag: "pds-pop-over", attributes: {
            id: props.id,
            class: props.className,
            'data-default-alignment': props.dataDefaultAlignment,
            'data-button-aria-text': react_utils_1.toAttribute(props.dataButtonAriaText),
            'data-icon-name': react_utils_1.toAttribute(props.dataIconName),
            'data-is-button-blend': react_utils_1.toAttribute(props.dataIsButtonBlend),
            'data-tooltip-text': react_utils_1.toAttribute(props.dataTooltipText),
            'data-header-name': react_utils_1.toAttribute(props.dataHeaderName),
            'data-tooltip-direction': react_utils_1.toAttribute(props.dataTooltipDirection),
            'data-label-text': react_utils_1.toAttribute(props.dataLabelText),
            'data-help-text': react_utils_1.toAttribute(props.dataHelpText),
            'data-is-app-action': react_utils_1.toAttribute(props.dataIsAppAction),
            'data-is-button-multi-action': react_utils_1.toAttribute(props.dataIsButtonMultiAction),
            'data-button-text': react_utils_1.toAttribute(props.dataButtonText),
        }, properties: {
            linkItems: props.linkItems,
            context: props.context
        }, listeners: {} }));
}
exports.PdsPopOver = PdsPopOver;

//# sourceMappingURL=pds-pop-over.js.map
